module.exports = __webpack_public_path__ + "img/pandarenh-m-90.14760732.gif";